(() => {
  'use strict';
  const c=JSON.parse(document.getElementById('pc-design-config').textContent);
  const money=n=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:c.currency||'USD',maximumFractionDigits:2}).format(n/100);
  const routes=c.routes;
  function asset(path){const [base,query]=String(path).split('?');return c.assets[base] || routes[base.replace('.html','')] || path;}
  function customizeURL(product,size,item){const url=new URL(routes[product],location.origin);url.searchParams.set('view','customizer');url.searchParams.set('size',size||'small');url.searchParams.set('product',product);if(item)url.searchParams.set('item',item);if(new URLSearchParams(location.search).get('quiet')==='1')url.searchParams.set('quiet','1');return url.pathname+url.search;}
  async function request(path,body){const response=await fetch(c.root+path,{method:body?'POST':'GET',credentials:'same-origin',headers:{Accept:'application/json',...(body?{'Content-Type':'application/json'}:{})},...(body?{body:JSON.stringify(body)}:{})});let data;try{data=await response.json();}catch{throw Error('We couldn’t read your cart. Please try again.');}if(!response.ok)throw Error(data.description||'Your changes could not be saved. Please try again.');return data;}
  // Custom events contain a fixed, non-personal schema. A missing privacy API
  // is not consent, and a Shopify bus publication is not GA4 delivery proof.
  const stepNames=['pet_details','photos','options','timing','summary'];
  const sentSteps=new Set(),sentSubmits=new Set(),memorialEmails=new Set();
  const adStorageKey='paw-ad-attribution';
  function trackingAllowed(kind){
    if(c.local||c.preview)return false;
    const method={analytics:'analyticsProcessingAllowed',marketing:'marketingAllowed'}[kind];
    try{return !!method && window.Shopify?.customerPrivacy?.[method]?.()===true;}catch{return false;}
  }
  function publishCustomizer(name,details,interactionKey){
    return window.PawCustomizerAnalytics?.emit(name,details,interactionKey)===true;
  }
  function customizerStep(number,product){
    if(!Number.isInteger(number)||number<1||number>5||!['figurine','keychain'].includes(product))return false;
    const key=product+':'+number;if(sentSteps.has(key))return false;
    const sent=publishCustomizer('customizer_step',{step_number:number,step_name:stepNames[number-1],product});
    if(sent)sentSteps.add(key);return sent;
  }
  function customizerSubmit(product,rush,pieceID,revision){
    if(!['figurine','keychain'].includes(product)||!pieceID)return false;
    // IDs only deduplicate in memory; they are never sent to analytics.
    const key=pieceID+':'+revision;if(sentSubmits.has(key))return false;
    const sent=publishCustomizer('customizer_submit',{rush:rush?'yes':'no',product},key);
    if(sent)sentSubmits.add(key);return sent;
  }
  function photoUploadFailed(reason){
    // Never send exception messages: upload errors may include filenames,
    // private URLs, pet names or a server response containing personal data.
    const allowed=['too_large','unsupported_type','image_decode','upload_failed'];
    return publishCustomizer('photo_upload_failed',{reason:allowed.includes(reason)?reason:'upload_failed'});
  }
  const cleanAd=value=>typeof value==='string'&&/^[A-Za-z0-9_-]{1,100}$/.test(value)?value:'';
  function clearAttribution(){try{sessionStorage.removeItem(adStorageKey);}catch{}}
  function attribution(existing=''){
    if(!trackingAllowed('marketing')){
      // Unknown/loading is not a refusal. Preserve an unread prior consented
      // tab value until the API is ready; erase on an explicit refusal.
      try{if(window.Shopify?.customerPrivacy?.marketingAllowed?.()===false)clearAttribution();}catch{}
      return '';
    }
    const kept=cleanAd(existing);if(kept)return kept;
    let found='';
    try{found=cleanAd(new URLSearchParams(location.search).get('utm_content'));}catch{}
    if(!found){
      // Historical Shopify landing-page fallback; read only after consent.
      // Never read/change Shopify's privacy cookies or retain the whole URL.
      try{
        const raw=document.cookie.split(';').map(x=>x.trim()).find(x=>x.startsWith('_landing_page='))?.slice(14);
        if(raw)found=cleanAd(new URL(decodeURIComponent(raw),location.origin).searchParams.get('utm_content'));
      }catch{}
    }
    try{
      if(found)sessionStorage.setItem(adStorageKey,JSON.stringify({id:found,at:Date.now()}));
      else{const saved=JSON.parse(sessionStorage.getItem(adStorageKey)||'null');if(saved&&Date.now()-saved.at>=0&&Date.now()-saved.at<86400000)found=cleanAd(saved.id);else clearAttribution();}
    }catch{}
    return found;
  }
  let memorialStatus='not-requested';
  async function markMemorial(email,age){
    if(age!=='Pet has passed away')return {status:'not-needed'};
    if(!trackingAllowed('marketing'))return {status:memorialStatus='consent-blocked'};
    if(typeof email!=='string'||!/^\S+@\S+\.\S+$/.test(email))return {status:memorialStatus='invalid-email'};
    if(memorialEmails.has(email))return {status:'already-requested',requestStatus:memorialStatus};
    if(typeof window.klaviyo?.identify!=='function')return {status:memorialStatus='sdk-unavailable'};
    try{
      memorialEmails.add(email);memorialStatus='requested';
      const result=window.klaviyo.identify({email,memorial:true});
      // The modern SDK resolves on its response. This is still not proof that
      // every server-side marketing/review workflow excludes this customer.
      if(!result||typeof result.then!=='function')return {status:memorialStatus='unverified'};
      await result;return {status:memorialStatus='sdk-acknowledged'};
    }catch{memorialEmails.delete(email);return {status:memorialStatus='failed'};}
  }
  const refreshAttribution=()=>{attribution();};
  document.addEventListener('visitorConsentCollected',refreshAttribution);
  document.addEventListener('shopifyCustomerPrivacyApiLoaded',refreshAttribution);
  attribution();
  let field=null, uploadQueue=Promise.resolve();
  const isCustomUpload=candidate=>candidate && typeof candidate.uploadFile==='function' && candidate.element?.closest('#pcz-uploadlift');
  window.addEventListener('upload:ready',event=>{if(isCustomUpload(event.detail))field=event.detail;});
  async function uploadOne(file){
    if(c.local){const response=await fetch('/__local/photo',{method:'POST',body:file,headers:{'Content-Type':file.type}});if(!response.ok)throw Error('Local photo could not be saved. Please try again.');return response.json();}
    if(!c.uploadEnabled)throw Error('Photo uploads aren’t working right now. Please contact us through pawchibi.com/pages/contact and we’ll help.');
    for(let n=0;!field && n<80;n++){
      const fields=window.Cloudlift?.upload?.App?.fields;
      if(Array.isArray(fields))field=fields.find(isCustomUpload);
      if(!field)await new Promise(resolve=>setTimeout(resolve,100));
    }
    if(!field)throw Error('The photo uploader is still loading. Wait a moment, then try again.');
    // The six visible slots own validation and the saved URLs. The hidden app
    // widget is only a transport; do not let replaced photos fill its six slots.
    // Cloudlift clearFiles normally forgets client-side selections. Never call
    // it in the order-edit mode that can also delete remote files.
    const canClear=typeof field.clearFiles==='function' && field._upload?._fileMeta?.settings?.serverDelete===false;
    if(!canClear)throw Error('The photo uploader could not start safely. Refresh this page and try again.');
    try {
      const result=await field.uploadFile(file);
      if(!result?.url || !PawCommerce.validPhoto(result.url))throw Error('The photo upload did not finish. Please try again.');
      return {url:result.url};
    } catch(error){
      throw Error(typeof error==='string'?error:(error?.message||error?.main||'We couldn’t upload this photo. Please try again.'));
    } finally {
      field.clearFiles();
      for(let n=0;n<100 && field.fileCount()>0;n++)await new Promise(resolve=>setTimeout(resolve,30));
    }
  }
  function upload(file){
    const result=uploadQueue.then(()=>uploadOne(file));
    uploadQueue=result.catch(()=>{});
    return result;
  }
  window.PC={...c,routes,money,asset,customizeURL,request,upload,trackingAllowed,customizerStep,customizerSubmit,photoUploadFailed,attribution,markMemorial,memorialStatus:()=>memorialStatus};
})();
